import React from "react";
import { Provider } from "react-redux";
import { createRoot, Root } from "react-dom/client";
import { BrowserRouter } from "react-router-dom"; // Or HashRouter if needed
import { store } from "../../../app/store";
import CheckoutPageContainer from "../components/CheckoutPageContainer";

// Store created roots by their container ID
const roots: Record<string, Root> = {};

/**
 * Initialize the CheckoutPageContainer component
 * @param rootId - ID of the DOM element to mount the component
 */
export function hydrateCheckoutContainer(rootId: string): void {
  const rootElement = document.getElementById(rootId);
  if (!rootElement) {
    console.error(`Failed to find root element with ID: ${rootId}`);
    return;
  }

  if (rootElement.dataset.reactInitialized === "true") {
    console.log(`Container ${rootId} is already initialized`);
    return;
  }

  try {
    if (roots[rootId]) {
      console.log(`Updating existing React root for ${rootId}`);
      roots[rootId].render(
        <React.StrictMode>
          <Provider store={store}>
            <BrowserRouter>
              <CheckoutPageContainer />
            </BrowserRouter>
          </Provider>
        </React.StrictMode>
      );
    } else {
      console.log(`Creating new React root for ${rootId}`);
      const root = createRoot(rootElement);
      roots[rootId] = root;
      root.render(
        <React.StrictMode>
          <Provider store={store}>
            <BrowserRouter>
              <CheckoutPageContainer />
            </BrowserRouter>
          </Provider>
        </React.StrictMode>
      );
    }

    rootElement.dataset.reactInitialized = "true";
    console.log("CheckoutPageContainer component successfully initialized");
  } catch (error) {
    console.error("Error initializing CheckoutPageContainer component:", error);
  }
}

// Declare global type for the hydration function
declare global {
  interface Window {
    hydrateCheckoutContainer?: (rootId: string) => void;
  }
}

// Export the hydration function for use in the global scope
if (typeof window !== "undefined") {
  window.hydrateCheckoutContainer = hydrateCheckoutContainer;
}
